import { Stack, Typography } from '@locus-taxy/encore-mui';

interface ProfileViewFieldProps {
  label: string;
  value: string | null | undefined;
}

/**
 * ProfileViewField — reusable label/value display pair for view mode.
 */
export function ProfileViewField({
  label,
  value,
}: Readonly<ProfileViewFieldProps>) {
  return (
    <Stack direction="column" spacing={1} flex={1}>
      <Typography variant="body2" fontWeight={500} color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" color="text.primary">
        {value ?? '—'}
      </Typography>
    </Stack>
  );
}
